const setWatermark = (str) => {
    const id = '1.23452384164.123412416';
    if (document.getElementById(id) !== null) document.body.removeChild(document.getElementById(id));
    const can = document.createElement('canvas');
    can.width = 420;
    can.height = 200;
    const cans = can.getContext('2d');
    cans.rotate((-10 * Math.PI) / 180);
    cans.font = 'normal bold 72px Vedana bold';
    cans.fillStyle = 'rgba(255,0,0,0.009)';
    cans.textBaseline = 'middle';
    cans.fillText(str, can.width / 10, can.height / 2);
    const div = document.createElement('div');
    div.id = id;
    div.style.pointerEvents = 'none';
    div.style.top = '0px';
    div.style.left = '0px';
    div.style.position = 'fixed';
    div.style.zIndex = '10000000';
    div.style.width = `1000%`;
    div.style.height =  `1000%`;
    div.style.background = `url(${can.toDataURL('image/png')}) left top repeat`;
    document.body.appendChild(div);
    return id;
};

const watermark = {
    set: (str) => {
        let id = setWatermark(str);
        if (document.getElementById(id) === null) id = setWatermark(str);
    },
    del: () => {
        const id = '1.23452384164.123412416';
        if (document.getElementById(id) !== null) document.body.removeChild(document.getElementById(id));
    },
};

// Export the watermark object
export default watermark;


// WEBPACK FOOTER //
// ./src/common/js/wartermark.js